import React, { useState, useEffect } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { StyleSheet, Text, View, FlatList, Platform, Image, Button, Share, ScrollView, Modal } from 'react-native';
import { SearchBar, ListItem, Icon } from 'react-native-elements';
import { Card } from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';
import { useDispatch, useSelector } from 'react-redux';
import { setRuleSections } from '../redux/ruleSectionsSlice';
import { clearAuthenticated, clearUser } from '../redux/userSlice';
import { selectItem } from '../redux/actions';
import Login from './Login';
import SignUp from './SignUp';
import CustomSearchBar from '../components/CustomSearchBar';
// import WelcomeModal from '../components/welcomeModal';

const highlightSearchTerm = (text, searchTerm) => {
    if (!searchTerm) {
        return text;
    }

    const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
    return (
        <Text>
        {parts.map((part, i) => (
            part.toLowerCase() === searchTerm.toLowerCase()
            ? <Text key={i} style={styles.highlighted}>{part}</Text>
            : part
        ))}
        </Text>
    );
};

console.disableYellowBox = true;

export default function Home({ route , navigation }) {
    const [searchTerm, setSearchTerm] = useState('');
    // const [filteredRules, setSortedRules] = useState([]);
    const dispatch = useDispatch();
    const [isSignUp, setIsSignUp] = useState(false);
    const user = useSelector((state) => state?.user);
    const isAuthenticated = user?.isAuthenticated;

    const ipfLogo = require('../assets/ipf_logo.png');

    useEffect(() => {
        if (user !== null && user.user && user.user.keepLoggedIn === false) {
            dispatch(clearUser());
            dispatch(clearAuthenticated());
        }
    }, []);

    useFocusEffect(
        React.useCallback(() => {
          // This runs when the screen comes into focus
          setSearchTerm('');
        }, [])
    );


    const ruleSections = useSelector((state) => state?.ruleSections);

    useEffect(() => {
        const fetchRules = async () => {
            try {
            const response = await fetch('https://pickleball-rules-app-backend.onrender.com/getRules');
            const data = await response.json();
            dispatch(setRuleSections(data));
            } catch (error) {
            console.error('Error fetching rules:', error);
            }
        };
        // Only fetch rules if ruleSections is empty
        if (!ruleSections || ruleSections.length === 0) {
            fetchRules();
        }
        }, [ruleSections]);


    const handleShowSignUp = () => {
        setIsSignUp(!isSignUp); // Toggle isSignUp
    };

    // const shareApp = async () => {
    //     try {
    //         const result = await Share.share({
    //             message: 'React Native | A framework for building native apps using React',
    //         });
    //         if (result.action === Share.sharedAction) {
    //             if (result.activityType) {
    //                 // shared with activity type of result.activityType
    //             } else {
    //                 // shared
    //             }
    //         } else if (result.action === Share.dismissedAction) {
    //             // dismissed
    //         }
    //     } catch (error) {
    //         Alert.alert(error.message);
    //     }
    // };

    // const getSortedRules = () => {
    //     const rules = (ruleSections || [])
    //       .filter((section) => {
    //         return (
    //           section.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //           (section.content
    //             ? section.content
    //               .flat()
    //               .some((paragraph) => paragraph.text.toLowerCase().includes(searchTerm.toLowerCase()))
    //             : false)
    //         );
    //       })
    //       .sort((a, b) => a.id - b.id);
    
    //     setSortedRules(rules);
    // };

    const sortedRules = (ruleSections || [])
    .filter((section) => {
        return (
            section.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (section.content
                ? section.content
                    .flat()
                    .some((paragraph) => paragraph.text.toLowerCase().includes(searchTerm.toLowerCase()))
                : false)
        );
    })
    .sort((a, b) => a.id - b.id);

  
    return (
        <ScrollView style={styles.container}>
            <View style={styles.body}>
                <View style={Platform.OS === 'web' ? webStyles.searchBarContainer : styles.searchBarContainer}>
                    <CustomSearchBar
                            placeholder="Search the rules..."
                            placeholderTextColor={'#794a78'}
                            onChangeText={(text) => setSearchTerm(text)}
                            value={searchTerm}
                        />
                    {/* <SearchBar
                        placeholder="Search the rules..."
                        placeholderTextColor={'#794a78'}
                        onChangeText={(text) => setSearchTerm(text)}
                        value={searchTerm}
                        inputStyle={styles.searchBar}
                        containerStyle={styles.searchBarContainer}
                        inputContainerStyle={searchTerm ? { ...styles.searchBarInputContainer, borderColor: 'red', borderWidth: 1 } : styles.searchBarInputContainer}
                        searchIcon={{ size: 28, color: '#794a78' }}
                        underlineColorAndroid="transparent"
                    /> */}
                </View>
                <FlatList
                    data={sortedRules}
                    extraData={sortedRules}
                    style={Platform.OS === 'web' ? webStyles.list : mobileStyles.list}
                    contentContainerStyle={{ paddingBottom: 80}}
                    keyExtractor={(item) => item.id.toString()}
                    renderItem={({ item }) => (
                        <Card containerStyle={Platform.OS === 'web' ? webStyles.listItemCard : mobileStyles.listItemCard} contentContainerStyle={Platform.OS === 'web' ? webStyles.listItemCardContentContainer : mobileStyles.listItemCardContentContainer }>
                            <LinearGradient
                                colors={['#ffebae', '#da7999']}
                                style={styles.cardColorGradient}
                            >
                                <View  style={styles.itemContainer}>
                                    <ListItem
                                        title={highlightSearchTerm(item.title, searchTerm)}
                                        style={styles.listItem}
                                        containerStyle={styles.listItemContainerStyle}
                                        onPress={() => {
                                            dispatch(selectItem(item));
                                            if (searchTerm !== '' && searchTerm !== undefined && searchTerm !== null) {
                                                navigation.navigate('RuleDetailsScreen', { searchTerm });
                                            }
                                            else {
                                                navigation.navigate('RuleDetailsScreen', { searchTerm: '' });
                                            }
                                        }}
                                        underlayColor={'transparent'}
                                        borderRadius={25} >
                                            {Platform.OS === 'web' ? (
                                                <View style={styles.item}>
                                                    <ScrollView 
                                                        horizontal 
                                                        showsHorizontalScrollIndicator={false}
                                                        style={{ flexGrow: 1 }}
                                                    >
                                                        <Text style={styles.itemId}>
                                                            {item.id}.
                                                            <Text style={styles.itemTitle}> {highlightSearchTerm(item.title, searchTerm)}</Text>
                                                        </Text>
                                                    </ScrollView>
                                                </View>
                                            ) : (
                                                <View style={styles.item}>
                                                    <Text style={styles.itemId}>{item.id}.
                                                        <Text style={styles.itemTitle}> {highlightSearchTerm(item.title, searchTerm)}</Text>
                                                    </Text>
                                                </View>
                                            )}
                                    </ListItem>
                                </View> 
                            </LinearGradient>
                        </Card>
                    )}
                />
            </View>
            <Modal
              animationType="slide"
              transparent={true}
              visible={!isAuthenticated}
              borderColor={'#653463'}
              borderWidth={3}
              onRequestClose={() => { setIsSignUp(false); }}>
                <View 
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                    }}
                >
                    <View 
                        style={Platform.OS === 'web'
                            ? (isSignUp ? webStyles.webSignUp : webStyles.webLogin)
                            : (isSignUp ? mobileStyles.mobileSignUp : mobileStyles.mobileLogin)}
                        
                    >
                        {isSignUp ? (
                            <SignUp onSignUp={handleShowSignUp} />
                        ) : (
                            <Login onSignUp={handleShowSignUp} />
                        )}
                    </View>


                </View>
            </Modal>
            {/* <WelcomeModal isAuthenticated={isAuthenticated} username={user?.user?.firstName} style={styles.centeredView} /> */}
        </ScrollView>
    );
}

const commonStyles = StyleSheet.create({
    container: {
        backgroundColor: '#fffaeb',
    },
    body: {
        backgroundColor: "#fffaeb",
    },    
    searchBarContainer: {
        width: '90%',
        height: 60,
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: 'transparent',
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 25,
        marginTop: 10,
    },
    searchBarInputContainer: {
        backgroundColor: '#ffebae',
        borderWidth: 0.5,
        borderBottomWidth: 0.5,
        borderRadius: 25,
        borderColor: '#653463',
        marginTop: 5,
    },
    searchBar: {
        fontSize: 16,
    },
    list: {
        width: '100%',
        height: '90%',
        borderColor: '#653463',
        paddingHorizontal: 10,
        marginTop: 15,
    },
    highlighted: {
        backgroundColor: '#ffebae',
    },
    itemContainer: {
        borderWidth: 0.1,
        borderRadius: 25,
    },
    listItemContainerStyle: {
        borderColor: '#653463',
        borderRadius: 25,
        height: 40,
    },
    listItemCard: {
        // maxWidth: 400,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 3,
            height: 3,
        },
        borderRadius: 25,
        shadowOpacity: 0.8,
        shadowRadius: 2,
        backgroundColor: 'transparent',
        borderColor: '#653463',
        borderWidth: 0.3,
        padding: 0,
    },
    item: {
        flexDirection: 'row',
        width: '100%',
        overflow: 'hidden',
    },
    itemId: {
        fontSize: 13,
        fontWeight: 'bold',
        color: '#653463',
        height: 20,
        paddingTop: 2,
    },
    itemTitle: {
        fontSize: 13,
        fontWeight: 'bold',
        height: 20,
    },
});

const styles = StyleSheet.create({
    ...commonStyles,
    firstContainer: {
        backgroundColor: '#fffaeb',
    },
    title: {
        fontSize: 30,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    text: {
        color: '#fff',
        fontSize: 20,
        marginBottom: 10,
    },
    cardColorGradient: {
        borderWidth: 0.1,
        borderRadius: 25,
        padding: 2,
    },
    iconContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    centeredView: {
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 22,
    },
});

const webStyles = StyleSheet.create({
    ...commonStyles,
    // Add web-specific styles here
    searchBarContainer: {
        width: '70%',
        minWidth: 240,
        height: 60,
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: 'transparent',
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderRadius: 25,
        marginTop: 10,
    },
    list: {
        width: '60%',
        minWidth: 380,
        height: '90%',
        borderColor: '#653463',
        paddingHorizontal: 0,
        marginTop: 15,
        alignSelf: 'center',
    },
    listItemCard: {
        // maxWidth: 400,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 3,
            height: 3,
        },
        borderRadius: 25,
        shadowOpacity: 0.8,
        shadowRadius: 2,
        backgroundColor: 'transparent',
        borderColor: '#653463',
        borderWidth: 0.3,
        padding: 0,
    },
    listItemCardContentContainer: {
    },
    modalView: {
        width: '40%',
        height: '80%',
        // backgroundColor: 'white',
        borderRadius: 20,
        overflow: 'hidden',
    },
    webSignUp: {
        width: '40%',
        // height: '90%',
        minWidth: 340,
        minHeight: 450,
        maxHeight: 630,
        backgroundColor: 'white',
        borderRadius: 20,
        overflow: 'hidden',
    },
    webLogin: {
        width: '40%',
        height: '75%',
        minWidth: 340,
        minHeight: 450,
        maxHeight: 550,
        backgroundColor: 'white',
        borderRadius: 20,
        overflow: 'hidden',
        borderColor: 'black',
        borderWidth: 1.5,
    },

});

const mobileStyles = StyleSheet.create({
    ...commonStyles,
    modalView: {
        width: '85%',
        height: '85%',
        backgroundColor: 'white',
        borderRadius: 10,
        overflow: 'hidden',
    },
    mobileSignUp: {
        width: '85%',
        height: '80%',
        backgroundColor: 'white',
        borderRadius: 20,
        overflow: 'hidden',
    },
    mobileLogin: {
        width: '85%',
        height: '70%',
        backgroundColor: 'white',
        borderRadius: 20,
        overflow: 'hidden',
    },
});